import React, { useState, useLayoutEffect } from "react";
import { Button, Image } from "antd";
import { ShoppingCartOutlined, StarOutlined } from "@ant-design/icons";
// import { StarOutlined } from "@ant-design/icons";
import { products } from "../../data";
import ProductTable from "../../component/product/ProductTable";
import "./ProductDetails.css";
import { useAppContext } from "../../context/AuthContext";
import HeaderCompo from "../../component/Header";

const ProductDetails = ({ productId, handleColorChange }) => {
  const { selectedProducts, setSelectedProducts } = useAppContext();
  const [data, setData] = useState(products);
  const [currentImge, setCurrentImage] = useState(0);

  useLayoutEffect(() => {
    handleColorChange("#FFFFFF");
  }, []);

  const product = {
    id: "46956",
    name: "Lamictal XR 120mg Extended-Release Tablet",
    ndc: "46956",
    supplier: "Bayer",
    price: 860.3,
    cost: 18,
    avg: 16.0,
    images: ["oene", "two", "three"],
    description:
      "LAMOTRIGINE (la MOE tri jeen) is used to control seizures in adults and children with epilepsy and Lennox-Gastaut syndrome. It is also used in adults to treat bipolar disorder.",
    usageInfo: {
      Prescription: "Required",
      Tier: "Tier ER",
      Administration: "Extended Release Oral Tablet",
      "Max Days Supply": "30 days",
      Strength: "120mg",
    },
  };

  // const renderPreviews = () => {
  //   return product.images.map((img, index) => (
  //     <Image
  //       src={`http://picsum.photos/400/320`}
  //       alt="Product Image"
  //       className="object-cover h-5 w-5"
  //       key={index}
  //       onClick={() => setCurrentImage(index)}
  //     />
  //   ));
  // };

  return (
    <>
    <HeaderCompo initialColor="#000833" />
    <div className="py-6 max-w-[1200px] mx-auto">
      <div className="mt-8 md:px-0 px-3">
        <div className="flex justify-space-between">
          <div>
            <p>Market / <p1> Lamictal 100mg Tablets</p1></p>
          </div>
          <div className="flex"><Button
            icon={<StarOutlined />}
            size="large"
            className=" bg-[#EFF1F9]">
          </Button><Button
            icon={<StarOutlined />}
            size="large"
            className=" bg-[#EFF1F9]">
            </Button></div>
        </div>
        <div className="flex flex-col md:gap-0 gap-6 md:flex-row md:space-x-8 space-x-0">
          <div>
            <Image
              src="http://picsum.photos/400/320"
              alt="Product Image"
              className="ProductDetails-img object-cover md:w-[398px] w-[398px]"
              height={398}
            />
            {/* <div>{renderPreviews()}</div> */}
          </div>
          <div className="flex-1 justify-between flex">
            <div>
              <h1 className="text-2xl font-bold ">{product.name}</h1>
              <p className="text-gray-500 mt-2 flex gap-3 items-center">
                {product.supplier}{" "}
                <span className="text-gray-500">
                  NDC:
                  {product.ndc}
                </span>
              </p>
              <div className="flex gap-3 flex-wrap">
                <p className="text-gray-500 p-3 bg-[#F9FAFD] rounded-lg">
                  Cost: <b className="text-black">${product.price}</b>
                </p>
                <p className="text-gray-500 bg-[#F9FAFD] p-3 rounded-lg">
                  AVG: <b className="text-black">${product.avg}</b>
                </p>
              </div>
              <p className="text-gray-500 mt-2 flex gap-3 items-center">
                Cost: <b className="text-black">${product.cost} </b>
                <span className="text-gray-500">
                  AVG: <b className="text-black">${product.avg}</b>
                </span>
              </p>
              <p className="mt-4 max-w-[500px] text-[#000833] font-semibold">
                {product.description}
              </p>
              <div className="mt-4 md:block hidden">
                <h3 className="text-lg text-gray-500">Usage Information</h3>
                <hr className="my-2 text-gray-500" />
                <ul className="list-disc  mt-2 flex flex-wrap gap-3">
                  {Object.entries(product.usageInfo).map(([key, value]) => (
                    <li
                      key={key}
                      className="list-none p-3 rounded-lg bg-[#F9FAFD] my-2"
                    >
                      <span className="font-semibold text-gray-500">
                        {key}:
                      </span>{" "}
                      <span className="font-extrabold">{value}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
            <div>
              <div className="fle flex-col items-center my-4  py-10 px-6 bg-[#F9FAFD] rounded-lg">
                <p className="text-4xl font-bold text-[#001997]">
                  ${product.price.toFixed(2)}
                </p>
                <p className="text-2xl font-semibold text-[#000833]">
                  $ 28.61 <span>Unit</span>
                </p>
                <Button
                  type="primary"
                  icon={<ShoppingCartOutlined />}
                  size="large"
                  className="flex-shrink-0 bg-[#001997]"
                >
                  Add to Cart
                </Button>
              </div>
            </div>
          </div>
          <div className="mt-4 md:hidden block">
            <h3 className="text-lg text-gray-500">Usage Information</h3>
            <ul className="list-disc  mt-2 flex flex-wrap gap-3">
              {Object.entries(product.usageInfo).map(([key, value]) => (
                <li
                  key={key}
                  className="list-none p-3 rounded-lg bg-[#F9FAFD] my-2"
                >
                  <span className="font-semibold text-gray-500">{key}:</span>{" "}
                  <span className="font-extrabold">{value}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
      {/* <div className="mt-8 md:px-0 px-3">
        <h2 className="ProductDetails-lastTitle text-lg font-semibold mb-4 md:pl-0 pl-3">
          Alternative Options
        </h2>
        <ProductTable
          setData={setData}
          data={data}
          setSelectedProducts={setSelectedProducts}
          products={products}
        />
      </div> */}
    </div>
    </>
  );
};

export default ProductDetails;